const headerValue = (headers, name) => {
  if (!headers) return '';
  if (typeof headers.get === 'function') {
    return headers.get(name) || headers.get(name.toLowerCase()) || '';
  }
  return headers[name] ?? headers[name.toLowerCase()] ?? '';
};

export const parseSportsnewRetryAfterMs = (headers, now = Date.now) => {
  const raw = headerValue(headers, 'Retry-After');
  if (raw === '') return null;
  const seconds = Number(raw);
  if (Number.isFinite(seconds) && seconds >= 0) return seconds * 1000;
  const retryAt = Date.parse(String(raw));
  return Number.isFinite(retryAt) ? Math.max(retryAt - now(), 0) : null;
};

const normalizedUserApiPath = (url = '') => {
  const rawUrl = String(url || '').trim();
  let pathname;
  try {
    pathname = new URL(rawUrl, 'https://sportsnew.local').pathname;
  } catch {
    pathname = rawUrl.split(/[?#]/)[0];
  }
  const normalized = String(pathname || '/').toLowerCase();
  const marker = '/api/v1/user';
  const markerIndex = normalized.indexOf(marker);
  const path = markerIndex >= 0 ? (normalized.slice(markerIndex + marker.length) || '/') : normalized;
  return path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path;
};

const responseCode = (data) => {
  const source = data && typeof data === 'object' ? data : {};
  const nested = source.data && typeof source.data === 'object' && !Array.isArray(source.data)
    ? source.data
    : {};
  return String(source.code ?? nested.code ?? source.errorCode ?? source.error_code ?? '').trim().toUpperCase();
};

export const isSportsnewListRetryable503 = (error) => (
  Number(error?.response?.status) === 503
  && normalizedUserApiPath(error?.config?.url) === '/sportsnew/fixtures'
  && (
    responseCode(error?.response?.data) === 'SPORTSNEW_LIST_TRANSITION'
    || parseSportsnewRetryAfterMs(error?.response?.headers) !== null
  )
);

export const sportsnewResponseTransportMetadata = (response) => {
  const retryAfterMs = parseSportsnewRetryAfterMs(response?.headers);
  const rawMembershipRevision = headerValue(response?.headers, 'X-Sportsnew-Membership-Revision');
  const membershipRevision = Number(rawMembershipRevision);
  return {
    httpStatus: response?.status,
    ...(retryAfterMs === null ? {} : { retryAfterMs }),
    ...(rawMembershipRevision !== ''
      && Number.isSafeInteger(membershipRevision)
      && membershipRevision >= 0
      ? { membershipRevision }
      : {}),
  };
};

/**
 * Keep retry metadata scoped to the Sportsnew fixture-list transport. The
 * shared Services decorator stays contract-compatible for every other API.
 */
export const decorateSportsnewFixtureListRequest = async (request) => {
  const base = { message: '', data: null, error: null, networkError: false };
  try {
    const response = await request();
    return { ...base, ...response?.data, ...sportsnewResponseTransportMetadata(response) };
  } catch (error) {
    if (error?.response) {
      return {
        ...base,
        message: 'Error in response',
        ...error.response.data,
        ...sportsnewResponseTransportMetadata(error.response),
      };
    }
    if (error?.request) {
      return {
        ...base,
        message: '인터넷 소켓 연결이 불안정 합니다.',
        ...error.request.data,
        networkError: true,
      };
    }
    return { ...base, message: error?.message || 'Request failed', error };
  }
};
